import { Button, Container, Grid, Paper, Typography, Box } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { url } from "../../baseUrl";
import DatatablePage from "../../Components/DataTable/DataTable";
import CustomizedSnackbars from "../../Components/SnackBar/SnackBar";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import RefreshIcon from "@mui/icons-material/Refresh";
import AddIcon from "@mui/icons-material/Add";
import { useSelector } from "react-redux";
import Navbar from "../../Components/Navbar/Navbar";

// 🎨 FIRST CLASS ASSIGNMENTS COLORS
const primaryDark = "#1a1e4c";      // Dark Navy
const primaryYellow = "#f5c522";    // Yellow/Gold
const gradientMain = `linear-gradient(135deg, ${primaryDark} 0%, ${primaryYellow} 100%)`;
const lightBg = "#fffdf5";
const cardBg = "#ffffff";

// Table header style
const tableHeaderStyle = {
  "& .MuiTableHead-root .MuiTableCell-root": {
    background: primaryDark,  // 🔥 Dark Navy background
    color: "white",
    fontWeight: "bold",
    fontSize: "14px",
    borderBottom: "none",
    padding: "12px 16px",
  },
  "& .MuiTableHead-root": {
    borderRadius: "12px",
    overflow: "hidden",
  }
};

const TransactionList = () => {
  const user = useSelector((state) => state.user.data);
  const [data, setData] = useState();
  const [isLoaded, setIsLoaded] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  let navigate = useNavigate();

  // 💰 GBP CURRENCY
  var formatter = new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const columns = [
    { label: "Action", field: "action", sort: "asc", width: 100 },
    { label: "Year", field: "year", sort: "asc", width: 100 },
    { label: "Month", field: "month", sort: "asc", width: 100 },
    { label: "Date", field: "dateTime", sort: "asc", width: 200 },
    { label: "Customer Name", field: "custName", sort: "asc", width: 250 },
    { label: "Email Address", field: "custEmail", sort: "asc", width: 250 },
    { label: "Phone Number", field: "custContactNumber", sort: "asc", width: 250 },
    { label: "Brand", field: "brand", sort: "asc", width: 150 },
    { label: "Order ID", field: "orderId", sort: "asc", width: 150 },
    { label: "Type Of Sale", field: "saleType", sort: "asc", width: 150 },
    { label: "Sale's Person", field: "salePerson", sort: "asc", width: 250 },
    { label: "Service", field: "detailDiscription", sort: "asc", width: 150 },
    { label: "Total Amount", field: "total", sort: "asc", width: 100 },
    { label: "Account", field: "account", sort: "asc", width: 100 },
    { label: "Payment Status", field: "paymentStatus", sort: "asc", width: 100 },
    { label: "Payment Time", field: "paymentTime", sort: "asc", width: 100 },
    { label: "Description", field: "discription", sort: "asc", width: 150 },
    { label: "Invoice-Link", field: "invoiceLink", sort: "asc", width: 300 },
    { label: "Stripe ID", field: "stripeId", sort: "asc", width: 150 },
  ];

  useEffect(() => {
    getAllTransactions();
  }, []);

  const getAllTransactions = async () => {
    try {
      setData([]);
      setIsLoaded(true);
      await axios
        .post(
          `${url}/transactions/getAllTransactions`,
          {
            brand: "First Class Assignments",  // 🔥 Sirf yahi brand ka data
          },
          {
            headers: {
              Authorization: `Bearer ${user.token}`,
            },
          }
        )
        .then((data) => {
          setData({
            columns,
            rows: data.data.data.map((item) => ({
              ...item,
              total: formatter.format(item.total),
              paymentStatus: item.paymentStatus ? (
                <Typography
                  variant="button"
                  style={{
                    padding: "6px 12px",
                    background: "#10b981",
                    borderRadius: "20px",
                    color: "white",
                    fontSize: "11px",
                    display: "inline-block",
                  }}
                >
                  Paid
                </Typography>
              ) : (
                <Typography
                  variant="button"
                  style={{
                    padding: "6px 12px",
                    background: "#ef4444",
                    borderRadius: "20px",
                    color: "white",
                    fontSize: "11px",
                    display: "inline-block",
                  }}
                >
                  Unpaid
                </Typography>
              ),
              paymentTime: item.paymentStatus
                ? new Date(item.updatedAt).toLocaleString("en-US", {
                    timeZone: "Asia/Karachi",
                  })
                : "",
              action: (
                <Box
                  onClick={() => navigate(`/transaction/record/${item._id}_readOnly`)}
                  sx={{
                    color: primaryYellow,
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    '&:hover': { opacity: 0.7, transform: "scale(1.05)" }
                  }}
                  title="View Invoice"
                >
                  <RemoveRedEyeIcon />
                </Box>
              ),
            })),
          });
          setIsOpen(true);
          setMessage("Data Loaded Successfully!");
          setSeverity("success");
          setIsLoaded(false);
        });
    } catch (error) {
      setIsLoaded(false);
      setIsOpen(true);
      setMessage(error.message);
      setSeverity("error");
    }
    setTimeout(() => {
      setIsOpen(false);
    }, 2000);
  };

  return (
    <>
      <Navbar />
      <Box
        sx={{
          maxWidth: "100%",
          minHeight: "calc(100vh - 70px)",
          background: `linear-gradient(135deg, ${lightBg} 0%, #fff8e0 100%)`,
          p: 2,
        }}
      >
        <Paper
          sx={{
            m: 1,
            p: 3,
            borderRadius: "20px",
            background: cardBg,
            boxShadow: "0 10px 30px rgba(26,30,76,0.1)",
            overflowX: "auto",
          }}
        >
          {/* Header */}
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3, flexWrap: "wrap", gap: 2 }}>
            <Typography
              variant="h5"
              sx={{
                background: gradientMain,
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                color: "transparent",
                fontWeight: "bold",
              }}
            >
              All Transactions
            </Typography>
            <Box sx={{ display: "flex", gap: 2 }}>
              <Button
                onClick={getAllTransactions}
                variant="contained"
                sx={{
                  background: gradientMain,
                  color: "white",
                  borderRadius: "30px",
                  textTransform: "none",
                  '&:hover': { 
                    background: primaryYellow,
                    transform: "translateY(-2px)",
                  },
                  transition: "all 0.3s ease"
                }}
              >
                <RefreshIcon sx={{ mr: 1, fontSize: "18px" }} />
                Reload
              </Button>
              <Button
                onClick={() => navigate(`/transaction/record/00000000000_CREATE`)}
                variant="contained"
                sx={{
                  background: gradientMain,
                  color: "white",
                  borderRadius: "30px",
                  textTransform: "none",
                  '&:hover': { 
                    background: primaryYellow,
                    transform: "translateY(-2px)",
                  },
                  transition: "all 0.3s ease"
                }}
              >
                <AddIcon sx={{ mr: 1, fontSize: "18px" }} />
                Generate New Link
              </Button>
            </Box>
          </Box>

          {/* Data Table with Dark Navy Header */}
          <Box sx={tableHeaderStyle}>
            <DatatablePage data={data} isLoaded={isLoaded} />
          </Box>
        </Paper>
      </Box>
      <CustomizedSnackbars isOpen={isOpen} severity={severity} message={message} />
    </>
  );
};

export default TransactionList;